<script lang="ts">
	import { getClassicWebUrl, getCurrentUser } from "$lib/components/currentUser";
	const CLASSIC_WEB_URL = getClassicWebUrl();
	const user = getCurrentUser();
	const accountUrl = user.caps.feature__new_app_account ? "/account" : `${CLASSIC_WEB_URL}/app/users/account`;
</script>

<div class="bg-red-600 py-4" role="banner">
	<a class="container-1200 lg:no-wrap flex flex-wrap justify-between text-white" href="{accountUrl}?s=delinquency-bar">
		<div class="flex-wrap items-center pr-2">
			<span class="material-icons mr-1.5 text-18">warning</span>
			<span class="font-bold">Credit card declined:</span>
			Your credit card on file was declined. Please update your billing details.
		</div>
		<div class="hidden font-bold lg:inline-block">Update billing</div>
	</a>
</div>
